import './main.css';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import Sider from "../../comps/sider/main";
import { Popconfirm , Alert, Skeleton, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Drawer, Space, Input, Upload, List, Flex  } from "antd";
import { CopyTwoTone, EditTwoTone, UploadOutlined, EyeOutlined, SendOutlined, CommentOutlined , LinkOutlined, DeleteOutlined } from '@ant-design/icons';
import { EditText, EditTextarea } from 'react-edit-text';
import callAPI from "../../comps/fetch/main";

// import { ShoppingCartOutlined, DollarOutlined, BarChartOutlined } from "@ant-design/icons";


import {
  ShoppingCartOutlined,
  BellOutlined,
  GiftOutlined,
  CheckCircleOutlined,
  WhatsAppOutlined,
  LineChartOutlined,
  FireOutlined,
   DollarOutlined, BarChartOutlined
} from "@ant-design/icons";



 function ConnectShopifyModal({ shopNotConnected, setShopNotConnected }) {
  const benefits = [
    {
      icon: <FireOutlined style={{ color: "#fa541c" }} />,
      text: "Automated follow-ups to showcase products directly in DMs",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/1.png",

    },
    {
      icon: <ShoppingCartOutlined style={{ color: "#1890ff" }} />,
      text: "Remind customers to add items to their cart",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/2.png",

    },
    {
      icon: <BellOutlined style={{ color: "#faad14" }} />,
      text: "Recover abandoned carts with automated notifications",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/3.png",

    },
    {
      icon: <GiftOutlined style={{ color: "#52c41a" }} />,
      text: "Post-purchase upsells to increase order value",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/4.png",

    },
    {
      icon: <CheckCircleOutlined style={{ color: "#722ed1" }} />,
      text: "Send order confirmations instantly in DMs",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/5.png",

    },
    {
      icon: <WhatsAppOutlined style={{ color: "#25D366" }} />,
      text: "Grow community with WhatsApp group or broadcast link",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/6.png",

    },
    {
      icon: <LineChartOutlined style={{ color: "#13c2c2" }} />,
      text: "Track every comment from lead to checkout",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/7.png",

    },
  ];

  return (
    <Modal
      footer={null}
      open={shopNotConnected}
      title="🚀 Connect Your Shopify Store"
      onCancel={() => setShopNotConnected(false)}
      centered
    >
      <p style={{ marginBottom: 16, fontSize: 15, fontWeight: 500 }}>
        Unlock the full power of Instagram + Shopify:
      </p>

      <List
        itemLayout="horizontal"
        dataSource={benefits}
        renderItem={(item) => (
          <List.Item style={{ border: "none", padding: "8px 0" }}>
            <List.Item.Meta
              avatar={item.icon}
              title={<span style={{ fontSize: 14 }}>{item.text}</span>}
            />
          </List.Item>
        )}
      />

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <Button
          type="primary"
          size="large"
          style={{ borderRadius: 8, padding: "0 28px" }}
        >
          Open Shopify
        </Button>
      </div>
    </Modal>
  );
}
function Shopify() {


    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const [showDrawer, setShowDrawer] = useState(false)
    const [showCreate, setShowCreate] = useState(false)
    const [drawerData, setDrawerData] = useState({})
    const [newURL, setNewURL] = useState({})
    const [callPostAPI, setCallPostAPI] = useState(false)
    const [loading, setLoading] = useState(false)
    const [dataPostedState, setDataPostedState] = useState()


    const [products, setProducts] = useState(undefined)
    const [nexPageToken, setNexPageToken] = useState()

    const [deleteLink, setDeleteLink] = useState()
    const [deleteState, setDeleteState] = useState()

    const [drawerOpen, setDrawerOpen] = useState(false);
    
    const [drawerProduct, setDrawerProduct] = useState(null);

    const [shopNotConnected, setShopNotConnected] = useState(false);



    useEffect(() => {
        if (products == undefined) {
            messageApi.open({type: 'loading',
                content: 'Loading your products...',
                duration: 0,
                key:'loading'
              })
            let apiURL = `shopify-products`
            callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: (data) => {
                if (data?.shop_connected == false)(
                    setShopNotConnected(true)
                )
                setProducts(
                    data?.data || []

                )
                    // setShopNotConnected(true)

                console.log("-=-=-=-=-=data?.data" , data?.data)

                messageApi.destroy()
            } })
        }
    }, [])


    useEffect(() => {
      if(!products){

      }else{
        products.map((product) => {
          console.log(product)
          console.log(product?.node?.options)
        })
      }
    },[products])


    // ...existing code...


    const benefits = [
    {
      icon: <FireOutlined style={{ color: "#fa541c" }} />,
      text: "Automated follow-ups to showcase products directly in DMs",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/1.png",

    },
    {
      icon: <ShoppingCartOutlined style={{ color: "#1890ff" }} />,
      text: "Remind customers to add items to their cart",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/2.png",

    },
    {
      icon: <BellOutlined style={{ color: "#faad14" }} />,
      text: "Recover abandoned carts with automated notifications",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/3.png",

    },
    {
      icon: <GiftOutlined style={{ color: "#52c41a" }} />,
      text: "Post-purchase upsells to increase order value",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/4.png",

    },
    {
      icon: <CheckCircleOutlined style={{ color: "#722ed1" }} />,
      text: "Send order confirmations instantly in DMs",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/5.png",

    },
    {
      icon: <WhatsAppOutlined style={{ color: "#25D366" }} />,
      text: "Grow community with WhatsApp group or broadcast link",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/6.png",

    },
    {
      icon: <LineChartOutlined style={{ color: "#13c2c2" }} />,
      text: "Track every comment from lead to checkout",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/7.png",

    },
    {
      icon: <LineChartOutlined style={{ color: "#13c2c2" }} />,
      text: "Track every comment from lead to checkout",
      image: "https://public-bucket-v3.s3.ap-south-1.amazonaws.com/instantdm-product/shopify-connect-1/8.png",

    },
  ];


return (
    <div className="page-layout">
      {contextHolder}
      <Sider />

      <div className="page-content">
        <Flex align='center' justify='space-between' style={{marginRight:"10px"}}>
        <h2>Shopify Products</h2>

                    <Button
            type="primary"
            size="large"
            style={{ borderRadius: 8, paddingInline: 32 }}
            href='https://apps.shopify.com/instantdm'
            target='_blank'
          >
            Open Shopify
            
          </Button>
        </Flex>
        <Divider />
        { shopNotConnected == true && 
         <div style={{ display: "grid", gap: 16 , maxWidth:"90%", margin:"0 auto"}}>
        {/* Intro */}
        <iframe style={{margin:"0 auto", maxWidth:"90%"}} width="560" height="300" src="https://www.youtube.com/embed/cfhkv4z7Lok?si=GIkIoFgDFd-7Ddew" title="InstantDM shopify demo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <p style={{ fontSize: 16, color: "#444", marginBottom: 8, textAlign:"center"}}>
          Boost your Instagram sales with automated follow-ups and upsells using InstantDM
        </p>
        <div style={{ display: "flex", gap: 12, flexDirection:"row", flexWrap:"wrap" }}>

        {
          benefits.map((benefit) => 
          <Card
            size="small"
            bordered
            style={{ borderRadius: 12, overflow: "hidden",

               width: "90%",        // mobile/tablet default
                maxWidth: 300,       // cap width on desktop
                margin: "0 auto", 
            }}
            cover={
              <div
                style={{
                  height: 350,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop:"20px",
                  background: "white", // optional: gives a neutral bg behind transparent images
                }}
              >
                <img
                  alt="Shopify Connect"
                  src={benefit.image}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            }
          >
            {/* <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {benefit.icon}
              <span>{benefit.text}</span>
            </div> */}
          </Card>
          
          )
        }
        </div>

        {/* Call to Action */}
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 8, paddingInline: 32 }}
            href='https://apps.shopify.com/instantdm'
            target='_blank'
          >
            Connect Shopify Store
          </Button>
          <p style={{ fontSize: 13, color: "#888", marginTop: 8 }}>
            Don’t miss out on sales — connect now to start making more from your Instagram DMs.
          </p>
        </div>
      </div>
        
        
        }
        {loading ? (
          <Skeleton active />
        ) : ((!products || products?.length === 0)&& !shopNotConnected) ? (
          <Empty description="No products found." />
        ) : (
          <Row gutter={[24, 24]}>
            {products.map((product) => (
              <Col xs={24} sm={12} md={8} lg={6} key={product?.node?.id}>
                <Card
                  hoverable
                  style={{ height: 320, display: "flex", flexDirection: "column", justifyContent: "space-between" }}
                  bodyStyle={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}
                  cover={
                    <img
                      alt={product?.node.title}
                      src={product?.node?.featuredMedia?.preview?.image?.url || "https://via.placeholder.com/300?text=No+Image"}
                      style={{ height: 160, objectFit: "cover" }}
                    />

                  }
                  actions={[
                    <Tooltip title="Show Details" key="details">
                      <Button
                        type="link"
                        onClick={() => {
                          setDrawerProduct(product);
                          setDrawerOpen(true);
                        }}
                        style={{ padding: 0 }}
                      >
                        Show Details
                      </Button>
                    </Tooltip>,
                  ]}
                >
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div style={{ fontWeight: 600, fontSize: 16 }}>{product?.node?.title}</div>
                    <div>
                      <Tag color={product?.node?.status === "ACTIVE" ? "green" : "red"}>
                        {product?.node.status}
                      </Tag>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        <Drawer
          title={drawerProduct?.node?.title}
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          width={600}
        >
          {drawerProduct && (
            <div>
              <Flex gap={20}   style={{ 
                    overflowX: "auto",   // enable horizontal scroll
                    flexWrap: "nowrap",  // prevent wrapping to next line
                  }}
                >
              <img
                alt={drawerProduct?.node?.title}
                src={drawerProduct?.node?.featuredMedia?.preview?.image?.url || "https://via.placeholder.com/300?text=No+Image"}
                style={{ width: "100%", maxHeight: 220, objectFit: "contain", marginBottom: 16, borderRadius: 8 }}
              />
                {
                  drawerProduct?.node?.media?.nodes?.map( (image, index) => {
                    if(index == 0) return
                  return <img src={image?.preview?.image?.url} style={{ width: "100%", maxHeight: 220, objectFit: "contain", marginBottom: 16, borderRadius: 8 }} />
                  })
                }
                  </Flex>
              <div style={{ marginBottom: 12 }}>
                <Tag color={drawerProduct?.node?.status  === "ACTIVE" ? "green" : "red"}>
                  {drawerProduct?.node?.status }
                </Tag>
                <span style={{ color: "#888", fontSize: 12, marginLeft: 8 }}>
                  {drawerProduct?.node?.vendor}
                </span>
              </div>
              {/* <div style={{ marginBottom: 8 }}>
                <b>Type:</b> {drawerProduct?.node?.product_type}
              </div> */}
              {/* <div style={{ marginBottom: 8 }}>
                <b>Handle:</b> {drawerProduct?.node?.handle}
              </div> */}
              <div style={{ marginBottom: 8 }}>
                {/* <b>Description:</b> */}
                <div style={{ color: "#555", marginTop: 4, whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{__html:drawerProduct?.node?.descriptionHtml}}>
                  
                </div>
              </div>
              {drawerProduct?.node?.options?.length > 1 &&<div style={{ marginBottom: 8 }}>
                <b>Variants:</b>
                 <ul style={{ paddingLeft: 18, margin: 0 }}>
                  {drawerProduct?.node?.options?.map((variant) => (
                    <li key={variant.id}>
                      {variant.name}
                    </li>
                  ))}
                </ul>
              </div>}
              {/* <div style={{ marginBottom: 8 }}>
                <b>Created:</b>{" "}
                {new Date(drawerProduct.created_at).toLocaleDateString()}
              </div>
              <div style={{ marginBottom: 8 }}>
                <b>Updated:</b>{" "}
                {new Date(drawerProduct.updated_at).toLocaleDateString()}
              </div>
              <div style={{ marginBottom: 8 }}>
                <b>Tags:</b> {drawerProduct.tags || "None"}
              </div>
              <div style={{ marginBottom: 8 }}>
                <b>Published:</b>{" "}
                {drawerProduct.published_at
                  ? new Date(drawerProduct.published_at).toLocaleDateString()
                  : "Not published"}
              </div> */}
              {/* <div style={{ marginTop: 16 }}>
                <Button
                  type="primary"
                  href={`https://${drawerProduct.handle ? `${drawerProduct.handle}` : "#"}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  icon={<EyeOutlined />}
                >
                  View on Shopify
                </Button>
                <Button
                  style={{ marginLeft: 8 }}
                  icon={<CopyTwoTone />}
                  onClick={() => {
                    navigator.clipboard.writeText(drawerProduct.id);
                    message.success("Product ID copied!");
                  }}
                >
                  Copy Product ID
                </Button>
              </div> */}
            </div>
          )}
        </Drawer>
      </div>

      {/* <ConnectShopifyModal shopNotConnected={shopNotConnected} onConnect={() => {}} /> */}

      <Modal      footer={null}
      // open={shopNotConnected}
      title="Connect Your Shopify Store"
      centered
      bodyStyle={{ padding: "24px" }}
    >
      <div style={{ display: "grid", gap: 16 }}>
        {/* Intro */}
        <p style={{ fontSize: 16, color: "#444", marginBottom: 8, textAlign:"center"}}>
          Boost your Instagram sales with automated follow-ups and upsells using InstantDM
        </p>
        <div style={{ display: "grid", gap: 12 }}>

        {
          benefits.map((benefit) => 
            <Card size="small" bordered={true} style={{ borderRadius: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {benefit.icon}
              <span>{benefit.text}</span>
            </div>
          </Card>
          
          )
        }
        </div>

        {/* Call to Action */}
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 8, paddingInline: 32 }}
            onClick={() => {}}
          >
            Connect Shopify Store
          </Button>
          <p style={{ fontSize: 13, color: "#888", marginTop: 8 }}>
            Don’t miss out on sales — connect now to start making more from your Instagram DMs.
          </p>
        </div>
      </div>
    </Modal>
    </div>
  );
}

export default Shopify;